import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'react-bootstrap';
import React from 'react';

export const MobileTable = ({
                                translationsGroup,
                                columnsNames,
                                items,
                                buttons,
                            }) => {

    const { t } = useTranslation();

    return (
        <Row>
            {items.map((item, index) => (
                <Col key={index} sm={12} md={6} lg={4}>
                    <Card className='mb-4'>
                        <Card.Body>
                            {columnsNames.map((column) => {
                                return (
                                    <Card.Text key={column + index}>
                                        <strong>{t(translationsGroup + column)}: </strong>{item[column]}
                                    </Card.Text>
                                );
                            })}
                            <div>
                                {buttons != null && buttons.length > 0
                                    ? buttons.map((button, index) => {
                                        const originalOnClick = button.element.props.onClick;
                                        const originalDisabled = button.element.props.disabled;
                                        return React.cloneElement(button.element, {
                                            onClick: button.element.props.obj != null
                                                ? (...args) => originalOnClick(...args)
                                                : () => originalOnClick(item),
                                            disabled: originalDisabled != null ? button.element.props.disabled(item) : false,
                                            obj: item,
                                            key: 'button-' + index,
                                        });
                                    })
                                    : <></>}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};